import {
  AIDA_FLOATING_PANEL_INSET_PX,
  AIDA_FLOATING_PANEL_MAX_HEIGHT_PX,
  AIDA_FLOATING_PANEL_SIDE_INSET_PX,
  AIDA_FLOATING_PANEL_WIDTH_PX,
} from './constants/presentation'

export interface ViewportSize {
  width: number
  height: number
  safeTop: number
}

export function floatingPanelMinY(viewport: ViewportSize) {
  return Math.max(AIDA_FLOATING_PANEL_INSET_PX, viewport.safeTop)
}

export function floatingPanelMaxHeight(viewport: ViewportSize) {
  return Math.max(
    0,
    Math.min(
      AIDA_FLOATING_PANEL_MAX_HEIGHT_PX,
      viewport.height - floatingPanelMinY(viewport) - AIDA_FLOATING_PANEL_INSET_PX,
    ),
  )
}

export function defaultFloatingPanelPosition(viewport: ViewportSize) {
  return clampFloatingPanelPosition({ x: viewport.width - 412, y: 96 }, viewport)
}

export function clampFloatingPanelPosition(
  point: { x: number; y: number },
  viewport: ViewportSize,
) {
  const minY = floatingPanelMinY(viewport)
  const maxHeight = floatingPanelMaxHeight(viewport)
  return {
    x: Math.max(
      AIDA_FLOATING_PANEL_SIDE_INSET_PX,
      Math.min(
        viewport.width - AIDA_FLOATING_PANEL_WIDTH_PX - AIDA_FLOATING_PANEL_SIDE_INSET_PX,
        point.x,
      ),
    ),
    y: Math.max(
      minY,
      Math.min(viewport.height - maxHeight - AIDA_FLOATING_PANEL_INSET_PX, point.y),
    ),
  }
}
